import React from "react";
import { FrameView } from "components/FrameView/FrameView";

export const IQala = () => {
  return (
    <FrameView
      title="IQala"
      src="https://app.powerbi.com/view?r=eyJrIjoiMTVkMTU4M2UtZWM1Yy00ZGQ1LTg2NTItNTIwMWZhNTRmNTc0IiwidCI6ImZkYTc1ZGJiLTc5MjUtNGM5Ny1hM2NhLTNiZDJmZDU0OWU5MCIsImMiOjl9"
    />
  );
};
